import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import Button from '@atlaskit/button';
import { B400 } from '@atlaskit/theme/colors';

import { fontSize } from '@/components/signup/utils/font-size';

import { useSiteActivationContext } from '../../hooks/site-activation-context';

export const SiteToggleButton = () => {
	const intl = useIntl();
	const { isWorkspaceProduct, showSitePicker, setShowSitePicker } = useSiteActivationContext();

	const toggleYourSiteButtonText = showSitePicker
		? isWorkspaceProduct
			? intl.formatMessage({
					id: 'siteActivation.nameSite.startNewWorkspaceButton',
					defaultMessage: 'Start a new workspace',
				})
			: intl.formatMessage({
					id: 'siteActivation.nameSite.startNewSiteButton',
					defaultMessage: 'Start a new site',
				})
		: isWorkspaceProduct
			? intl.formatMessage({
					id: 'siteActivation.nameSite.useExistingWorkspaceButton',
					defaultMessage: 'Use an existing workspace',
				})
			: intl.formatMessage({
					id: 'siteActivation.nameSite.useExistingSiteButton',
					defaultMessage: 'Use an existing site',
				});

	return (
		<Button appearance="link" css={buttonCss} onClick={() => setShowSitePicker(!showSitePicker)}>
			<span css={buttonInnerCss}>
				{toggleYourSiteButtonText}
				<svg aria-hidden={true} fill="currentColor" height="8" width="12">
					<path d="m7.908 0-1.08 1.202 1.75 1.948H1.264C.842 3.15.5 3.53.5 4c0 .469.342.85.763.85H8.58l-1.75 1.948L7.907 8 11.5 4 7.908 0Z" />
				</svg>
			</span>
		</Button>
	);
};

const buttonCss = css({
	paddingInline: '0 !important',
});

const buttonInnerCss = css({
	alignItems: 'center',
	display: 'flex',
	fontSize: fontSize.sm,
	gap: 4,
	color: B400,
});
